var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42 15.16l3-2.65a.41.41 0 00-.22-.7l-1.5-.18A12 12 0 0127.94 14a1 1 0 001 .88h.12a1 1 0 00.88-1.11 14 14 0 00-27.25-2.4L1 11.18a.4.4 0 00-.38.62l2.26 3.29a.39.39 0 00.54.07zm28.01 4.78l-2.26-3.29a.39.39 0 00-.59-.07l-3 2.65a.4.4 0 00.22.69l1.48.19a12 12 0 01-23.24-2.4 1.007 1.007 0 00-2 .24 14 14 0 0027.25 2.4l1.73.21a.4.4 0 00.41-.62z"
  })));
}

export default SvgRepeat;